import { useState, useEffect } from "react";
import styled from "styled-components/macro";
import {
  IconButton,
  Button,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  OutlinedInput,
  Paper,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormGroup from "@mui/material/FormGroup";
import { BREAKPOINT_MOBILE } from "../../constants/constants";
import * as emailjs from "emailjs-com";
import { useSpring, animated } from "@react-spring/web";

const FeedbackFormStyles = styled(Paper).attrs({ elevation: 24 })`
  background: #fff;
  width: 85vw;
  max-width: 500px;
  position: relative;
  border-radius: 8px;
  .title {
    padding-bottom: 8px;
  }
  .btnClose {
    position: absolute;
    top: 0px;
    right: 0px;
  }
  .formWrapper {
    padding: 24px;
    & > div > div {
      padding: 0 0 16px 0;
    }
  }
  button[type="submit"] {
    margin: 4px 0 -10px 0;
  }
  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    .formWrapper {
      padding: 36px;
    }
  }
`;

// tslint:disable-next-line: no-big-function
// tslint:disable-next-line cognitive-complexity
export default function FeedbackFormModal({
  isFeedbackOpen,
  setIsFeedbackOpen,
}: {
  isFeedbackOpen: boolean;
  setIsFeedbackOpen: any;
}) {
  const springUpDown = useSpring(
    isFeedbackOpen
      ? {
          transform: `translateY(0px)`,
          opacity: 1,
        }
      : {
          transform: `translateY(50px)`,
          opacity: 0,
        }
  );

  const customerKey = window.location.pathname.split("/")[1];
  const customer = customerKey && customerKey.toUpperCase();

  const [state, setState] = useState({
    subject: "",
    name: "",
    email: "",
    message: "",
    customer,
  });

  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const { subject, email, message } = state; // required form fields
  const onSubmit = evt => {
    setSubmitted(true);
    if (!!subject && !!email && !!message) {
      setSending(true);
      const templateParams = state;
      emailjs
        .send(
          "gmail",
          "template_dvCqskD1",
          templateParams,
          "user_8fobKOaX0ntUGFcozbfrT"
        )
        .then(
          response => {
            console.log("SUCCESS!", response.status, response.text);
            setSending(false);
            setSent(true);
            setTimeout(() => setIsFeedbackOpen(false), 1000);
          },
          err => {
            console.log("FAILED...", err);
          }
        );
    } else {
      console.log(
        `Missing required form fields:${!subject ? " subject" : ""}${
          !email ? " email" : ""
        }${!message ? " message" : ""}`
      );
    }
  };

  const handleChange = evt => {
    console.log(evt.target);
    setState({ ...state, [evt.target.name]: evt.target.value });
  };
  useEffect(() => {
    return () => {
      setSubmitted(false);
    };
  }, [isFeedbackOpen]);
  return (
    <animated.div
      style={{
        ...springUpDown,
        pointerEvents: isFeedbackOpen ? "auto" : "none",
      }}
    >
      <FeedbackFormStyles>
        <div className="btnClose">
          <IconButton onClick={() => setIsFeedbackOpen(false)} size="large">
            <CloseIcon />
          </IconButton>
        </div>

        <div className="formWrapper">
          <Typography variant="h6" className="title">
            Feedback
          </Typography>

          <FormGroup>
            <FormControl variant="outlined">
              <InputLabel htmlFor="subject-input">Subject*</InputLabel>
              <Select
                onChange={handleChange}
                name="subject"
                required={true}
                error={submitted && !subject}
                value={subject}
                input={
                  <OutlinedInput
                    name="subject"
                    id="subject-input"
                    label="Subject*"
                  />
                }
              >
                <MenuItem value={"improvement"}>Improvement</MenuItem>
                <MenuItem value={"bug"}>Bug</MenuItem>
                <MenuItem value={"configuration"}>Settings</MenuItem>
                <MenuItem value={"other"}>Other</MenuItem>
              </Select>
              {submitted && !subject && (
                <FormHelperText style={{ color: "#f44336" }}>
                  This field is required
                </FormHelperText>
              )}
            </FormControl>

            <TextField
              variant="outlined"
              fullWidth={true}
              onChange={handleChange}
              type="text"
              name="name"
              autoFocus={true}
              placeholder="Name"
            />

            <FormControl>
              <TextField
                variant="outlined"
                fullWidth={true}
                onChange={handleChange}
                type="email"
                name="email"
                placeholder="Email*"
                required={true}
                error={submitted && !email}
              />
              {submitted && !email && (
                <FormHelperText style={{ color: "#f44336" }}>
                  This field is required
                </FormHelperText>
              )}
            </FormControl>

            <FormControl>
              <TextField
                variant="outlined"
                fullWidth={true}
                onChange={handleChange}
                type="text"
                name="message"
                placeholder="Message*"
                required={true}
                error={submitted && !message}
                multiline={true}
                rows={6}
              />
              {submitted && !subject && (
                <FormHelperText style={{ color: "#f44336" }}>
                  This field is required
                </FormHelperText>
              )}
            </FormControl>

            <Button disabled={sending} type="submit" onClick={onSubmit}>
              {sending ? "Sending..." : sent ? "Sent!" : "Submit"}
            </Button>
          </FormGroup>
        </div>
      </FeedbackFormStyles>
    </animated.div>
  );
}
